function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInstargram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_instargram_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z",
  "data-name": "Rectangle 1041",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-152 -1037)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  "data-name": "Rectangle 1015",
  rx: 14,
  style: {
    fill: "#c4c4c4"
  },
  transform: "translate(152 1037)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1293"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1292",
  style: {
    clipPath: "url(#icon_instargram_svg__a)"
  },
  transform: "translate(158.332 1043.592)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.671 0H4.33A4.33 4.33 0 0 0 0 4.33v6.341A4.33 4.33 0 0 0 4.33 15h6.341A4.33 4.33 0 0 0 15 10.671V4.33A4.33 4.33 0 0 0 10.671 0m2.948 10.782a2.874 2.874 0 0 1-2.874 2.874h-6.49a2.874 2.874 0 0 1-2.874-2.874V4.293a2.874 2.874 0 0 1 2.874-2.874h6.489a2.874 2.874 0 0 1 2.874 2.874z",
  "data-name": "Path 498",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.862 34.321a3.892 3.892 0 1 0 3.892 3.892 3.89 3.89 0 0 0-3.892-3.892m0 6.415a2.523 2.523 0 1 1 2.523-2.523 2.523 2.523 0 0 1-2.523 2.523",
  "data-name": "Path 499",
  style: {
    fill: "#fff"
  },
  transform: "translate(-30.362 -30.676)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.85 24.39a.907.907 0 1 0 .907.907.907.907 0 0 0-.907-.907",
  "data-name": "Path 500",
  style: {
    fill: "#fff"
  },
  transform: "translate(-89.328 -21.8)"
})))));
export default SvgIconInstargram;